<ion-app>
  <div id="sf2-main-playback-synth" class="sf2-main-playback-synth" aria-hidden="true"></div>
  <div class="landscape-guard" *ngIf="requireLandscape">
    <div class="landscape-card">
      <div class="landscape-title">Landscape Required</div>
      <div class="landscape-copy">Rotate your phone or tablet to landscape for the notation workspace.</div>
    </div>
  </div>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" class="app-menu">
      <ion-content>
        <div class="menu-column">
          <ion-list id="main-nav-list" class="primary-nav">
            <ion-list-header>
              <div class="brand-lockup">
                <div class="brand-kicker">SaRaGaLabs</div>
                <div class="brand-title">Rachana</div>
              </div>
            </ion-list-header>
            <ion-note>Composition studio for taal, notation, and lyrics.</ion-note>

            @for (p of appPages; track p; let i = $index) {
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" [name]="p.icon"></ion-icon>
                  <ion-label>{{ p.title }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            }

            <ion-item lines="none" button="true" detail="false" (click)="toggleUtilityFolder()" [class.selected]="utilityFolderOpen">
              <ion-icon aria-hidden="true" slot="start" name="folder-open-outline"></ion-icon>
              <ion-label>More</ion-label>
            </ion-item>

            @if (utilityFolderOpen) {
              <div class="utility-folder">
                @for (p of utilityPages; track p) {
                  <ion-menu-toggle auto-hide="false">
                    <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                      <ion-icon aria-hidden="true" slot="start" [name]="p.icon"></ion-icon>
                      <ion-label>{{ p.title }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                }
                <ion-item lines="none" button="true" (click)="toggleTheme()">
                  <ion-icon aria-hidden="true" slot="start" [name]="isLightTheme ? 'moon-outline' : 'sunny-outline'"></ion-icon>
                  <ion-label>{{ isLightTheme ? 'Use Dark Theme' : 'Use Light Theme' }}</ion-label>
                </ion-item>
                <ion-menu-toggle auto-hide="false">
                  <ion-item routerDirection="forward" routerLink="/user" lines="none" detail="false" routerLinkActive="selected">
                    <ion-icon aria-hidden="true" slot="start" ios="log-in-outline" md="log-in-outline"></ion-icon>
                    <ion-label>User</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              </div>
            }
          </ion-list>

          <section class="breadcrumb-box" aria-label="Navigation breadcrumbs">
            <div class="breadcrumb-kicker">Current View</div>
            <div class="breadcrumb-title">{{ currentPageLabel }}</div>
            <div class="breadcrumb-trail">
              @for (crumb of breadcrumbs; track crumb; let last = $last) {
                <span [class.breadcrumb-current]="last">{{ crumb }}</span>
                @if (!last) {
                  <span class="breadcrumb-separator">/</span>
                }
              }
            </div>
          </section>
        </div>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
